export default "__VITE_ASSET__CrLvBB5C__"